import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';
import { ConfirmStageDialogComponent } from 'src/app/shared/confirm-stage-dialog/confirm-stage-dialog.component';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css']
})
export class ProjectsComponent implements OnInit {
  displayedColumns: string[] = ['srNo',
    'projectName', 'projectManager','assignedTo',
    'startDate', 'endDate','stage', "action"
  ];


  dataSource = new MatTableDataSource([]);
  searchKeyword = "";
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private dialog: MatDialog,
    private router: Router
  ) {}



  ngOnInit(): void {

    this.fetchData();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }
  fetchData() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getProject(params).subscribe({
      next: (res: any) => {
        console.log(res);
        this.dataSource.data = res.data;
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  deleteProject(item: any) {
  const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
    width: '400px',
    data: { itemName: item.project_name }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
        this.apiService.deleteProject(item.project_id).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success("Project deleted successfully");
        this.fetchData();
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
    }
  });
}


stageProject(item: any) {
  const dialogRef = this.dialog.open(ConfirmStageDialogComponent, {
    width: '600px',
    data: { 
      project: item,
      itemName: item.project_name 
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      // Handle stage update logic here
      console.log('Stage updated for project:', item.project_name, 'with data:', result);
      
      // Prepare the payload
      const payload = {
        stage: result.stages,
        stages: result.stages,
        assigned_to: result.assigned_to,
        date: result.date,
        assignedStaffName: result.assignedStaffName
      };

      // API call to update project stage
      this.apiService.updateProjectStage(result.projectId || item.id || item.project_id, payload).subscribe({
        next: (res: any) => {
          console.log('Stage update response:', res);
          this.toastrMsgService.success(res.message || "Project stage updated successfully");
          this.fetchData();
          if (result.stages === 'Survey') {
            const projectId = result.projectId || item.id || item.project_id;
            this.router.navigate(['/home/add-survey'], { queryParams: { projectId, projectName: item.project_name } });
          }
        },
        error: (err) => {
          console.error('Stage update error:', err);
          this.toastrMsgService.error(err.error?.message || err.error?.errorMessage || "Failed to update project stage");
        },
        complete: () => console.log('Stage update complete')
      });
    }
  });
}

  getStatusColor(status: string): 'primary' | 'accent' | 'warn' {
  switch (status) {
    case 'Pre-Planning':
    case 'Planning':
      return 'primary';
    case 'Survey':
    case 'Design Revisions & Scope Adjustments':
      return 'accent';
    case 'Execution':
    case 'Closure':
      return 'warn';
    default:
      return 'primary';
  }
}



}
